import { StudentsAndInvitesTableEntry } from 'types/organization/addStudentsToClassUI';

export const getFilteredEntriesToAdd = (filteredEntries: StudentsAndInvitesTableEntry[], selectedIds: string[]) =>
  filteredEntries.filter((student) => !selectedIds.find((selectedId) => selectedId === student.id));

